<template>
	<div class="betslip__bet" :class="{ 'betslip__bet--expired': expired }">
		<button class="betslip__bet__remove" @click="removeBet()">&#10005;</button>
		<div class="betslip__bet__details">
			<div class="betslip__bet__row betslip__bet__row--top">
				<span>
					<span class="betslip__bet__display bold">
						<router-link class="betslip__bet__link" :to="getRoute()">{{
							bet.game_description | toTitleCase
						}}</router-link>
					</span>
				</span>
			</div>
			<div class="betslip__bet__row">
				<span>{{ bet.odd.name | toTitleCase }}</span> •
				<span class=""
					>{{ bet.odd.odd_key | toTitleCase }}
					<!-- {{ getSpecialBetValue() | toTitleCase }} -->
				</span>
			</div>
			<div
				class="betslip__bet__row betslip__bet__row--bottom"
				v-show="!expired"
			>
				<span
					v-if="!expired"
					class="betslip__bet__marker betslip__bet__marker--starttime"
				>
					<span>Starts {{ bet.start_time | time }}</span>
				</span>
			</div>
		</div>
		<div class="betslip__bet__row betslip__bet__row--middle">
			<span class="odd-value bold" v-if="!expired">{{
				bet.odd.odd_value
			}}</span>
		</div>
		<div
			class="betslip__bet__row betslip__bet__row--bottom"
			:class="{ 'betslip__bet__row--bottom--expired': expired }"
			v-if="expired"
		>
			<div>
				<span class="betslip__bet__marker betslip__bet__marker--expired"
					>Started</span
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "bet",
	props: ["bet", "currentTime"],
	computed: {
		expired() {
			return false;
			return (
				+new Date(this.bet.start_time.replace(/-/g, "/")) <= this.currentTime
			);
		},
	},
	methods: {
		removeBet() {
			let vm = this;
			vm.$store.commit("removeFromVirtualBetslip", vm.bet.parent_virtual_id);
		},
		getSpecialBetValue() {
			return this.bet.odd.special_bet_value
				? `(${this.bet.odd.special_bet_value})`
				: "";
		},
		getRoute() {
			return `/virtuals/markets?id=${this.bet.parent_virtual_id}`;
		},
	},
};
</script>
